import { createFileRoute, redirect } from '@tanstack/react-router'

import { isGateVisitorAuthenticated } from '@/access/gate-session'
import { getPortalGate, PORTAL_GATE_PATH } from '@/access/portal-access'
import { isAdmin } from '@/hooks/use-is-admin'
import { BetaLockedPage } from '@/pages/beta-locked/beta-locked-page'
import { store } from '@/store'

export const Route = createFileRoute('/beta-locked')({
  beforeLoad: async () => {
    if (!(await isGateVisitorAuthenticated())) {
      throw redirect({ to: '/login', replace: true })
    }

    // Root-level route, outside the _private/_auth layouts — this guard is the
    // ONLY enforcement on /beta-locked. Recompute the same gate the layout guards
    // use (single source of truth): admins reach the admin area, an already-allowed
    // partner goes to their dashboard instead of being stranded on a dead screen,
    // and a partner whose real block is the T&C gate is sent to /accept-terms.
    if (isAdmin()) {
      throw redirect({ to: '/admin/partners', replace: true })
    }
    const gate = getPortalGate(store.getState().partner)
    if (gate.kind === 'allow') {
      throw redirect({ to: '/dashboard', replace: true })
    }
    if (gate.kind !== 'beta-locked') {
      throw redirect({ to: PORTAL_GATE_PATH(gate), replace: true })
    }
  },
  component: BetaLockedPage,
})
